import { Button } from '@design-system/button';
import { Icon } from '@design-system/icon';
import { InputField } from '@design-system/input-field';
import { Typography } from '@design-system/typography';
import classnames from 'classnames';
import React, { FC, useContext, useState } from 'react';

import { StoreContext } from '~/context/shopify';
import { formatPrice } from '~/utils/currencyFormatting';

import { DiscountCodeProps } from './models';

const DiscountCode: FC<DiscountCodeProps> = ({ discountCode }) => {
  const { checkout, applyDiscount, hasDiscountCodeError, removeDiscount } =
    useContext(StoreContext);
  const [inputValue, setInputValue] = useState('');

  const handleCodeChange = (e) => {
    setInputValue(e.target.value);
  };

  return (
    <div
      className={classnames('shopping-cart__summary-discount-code', {
        'shopping-cart__summary-discount-code--discount-applied':
          checkout.discountApplications.length > 0,
      })}
    >
      <InputField
        isHidden={checkout.discountApplications.length > 0}
        id="shopping-cart__summary-discount-input"
        className="shopping-cart__summary-discount-input"
        label={discountCode.label}
        additionalHeadContent={
          checkout.discountApplications.length > 0 ? (
            <Typography
              className="shopping-cart__summary-discount-code-price"
              content={
                checkout.discountApplications[0].value.percentage
                  ? `-${checkout.discountApplications[0].value.percentage}%`
                  : `-${formatPrice(
                      checkout.discountApplications[0].value.currencyCode,
                      Number(checkout.discountApplications[0].value.amount)
                    )}`
              }
              variant="body"
            />
          ) : undefined
        }
        tooltipLabel="tooltip"
        tooltipContent={<span>{discountCode.tooltipText}</span>}
        name="InputDiscount"
        errorMessage={
          hasDiscountCodeError
            ? discountCode.inputValidationErrorText
            : undefined
        }
        placeholder={discountCode.inputPlaceholder}
        value={inputValue}
        onChange={handleCodeChange}
      />
      {checkout.discountApplications.length <= 0 ? (
        <Button
          {...discountCode.applyButton}
          className={classnames(
            'shopping-cart__summary-discount-apply-button',
            {
              'shopping-cart__summary-discount-apply-button--error':
                hasDiscountCodeError,
            }
          )}
          onClick={() => applyDiscount(checkout.id, inputValue)}
        >
          {discountCode.applyButton.children}
        </Button>
      ) : (
        checkout.discountApplications.map((item) => (
          <div
            key={item.code}
            className="shopping-cart__summary-discount-code-applied"
          >
            <Icon
              className="shopping-cart__summary-discount-code-icon"
              icon={discountCode.icon[0].icon}
            />
            <Typography
              className="shopping-cart__summary-discount-code-title"
              content={item.code}
              variant="body"
              size="m"
              weight="medium"
            />
            <Button
              {...discountCode.removeButton}
              className="shopping-cart__summary-discount-remove-button"
              onClick={() => removeDiscount(checkout.id)}
            >
              {discountCode.removeButton.children}
            </Button>
          </div>
        ))
      )}
    </div>
  );
};

export default DiscountCode;
